import userSelector from "@/store/selectors/userSelector";
import { useSelector } from "react-redux";
import { canPerformClientAction, type ClientAction, type ClientRole } from "@/helpers/clientPermissions";

interface IHasPermissionWrapperProps {
  permission?: string;
  role?: ClientRole;
  clientAction?: ClientAction;
  primaryOnly?: boolean;
  children: React.ReactNode;
}

const HasPermissionWrapper = ({children, permission, role, clientAction, primaryOnly}: IHasPermissionWrapperProps) => {
  const user = useSelector(userSelector);
  if (!user) return null;
  if (permission && !user.privileges?.includes(permission)) return null;
  if (role && user.clientRole !== role && !user.primaryUser) return null;
  if (clientAction && !canPerformClientAction(user.clientRole, clientAction, user.primaryUser)) return null;
  if (primaryOnly && !user.primaryUser) return null;
  return children;
};

export default HasPermissionWrapper;
